const TRACKABLE_QRCODE_TPL = {
  type: "row",
  children: [
    {
      type: "col",
      children: [
        {
          type: "wechat-trackable-qrcode",
          data: {
            qrcodeUrl: "https://www.example.com",
            template: `
              <section style="text-align: center;">
                <img
                  rdc-t-qr
                  rdc-t-url="{{qrcodeUrl}}"
                  height="215"
                  width="215"
                  src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/a976a511-3cea-467e-847b-e8e0e99f42a4/00ebb922-eae6-11ec-948c-acde48001122/survey/qrcode_61340942_5d391ae5241f46374f5ba20850cdc35a.png"
                />
              </section>
            `,
          },
        },
      ],
    },
  ],
}

export default TRACKABLE_QRCODE_TPL;
export const WECHAT_TRACKABLE_QRCODE_TPL_LIST = [TRACKABLE_QRCODE_TPL];
